import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { useState } from 'react';
import '../CatalogoClientes.scss';

export const ContactDialog = ({ visible, onHide, colaboradores, onSave }) => {
    const [selectedColaborador, setSelectedColaborador] = useState(null);

    const handleSave = () => {
        if (!selectedColaborador) {
            return;
        }

        onSave(selectedColaborador);
        setSelectedColaborador(null);
    };

    const handleCancel = () => {
        setSelectedColaborador(null);
        onHide();
    };

    const footerContent = (
        <div className="flex justify-content-end gap-2">
            <Button
                label="Cancelar"
                icon="pi pi-times"
                onClick={handleCancel}
                severity="secondary"
                text
            />
            <Button
                label="Guardar"
                icon="pi pi-check"
                onClick={handleSave}
                severity="success"
            />
        </div>
    );

    return (
        <Dialog
            header="Agregar Contacto"
            visible={visible}
            onHide={handleCancel}
            footer={footerContent}
            style={{ width: '450px' }}
            breakpoints={{ '960px': '75vw', '640px': '90vw' }}
        >
            <div className="contact-dialog__content">
                <label htmlFor="colaborador" className="contact-dialog__label">
                    Seleccionar Colaborador *
                </label>
                <Dropdown
                    id="colaborador"
                    value={selectedColaborador}
                    onChange={(e) => setSelectedColaborador(e.value)}
                    options={colaboradores}
                    optionLabel="nombre"
                    placeholder="Seleccione un colaborador"
                    filter
                    filterBy="nombre,email"
                    emptyMessage="No se encontraron colaboradores"
                    className="contact-dialog__dropdown"
                />
            </div>
        </Dialog>
    );
};